import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Folder, ChevronRight, Package } from 'lucide-react'
import './CategoryCard.css'

const CategoryCard = ({ category }) => {
  const [isHovering, setIsHovering] = useState(false)

  return (
    <figure 
      className="category-page-card"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <Link to={`/category/${category.slug}`} className="block h-full">
        <div className="category-page-card__image-wrapper">
          <img 
            src={category.image ? `/uploads/categories/${category.image}` : 'https://via.placeholder.com/300x200?text=No+Image'} 
            alt={category.name}
          />
          
          {/* Hover Overlay */}
          <div className="category-page-card__hover-overlay">
            <div className="category-page-card__hover-content">
              <Folder size={32} className="mx-auto mb-2" />
              <span className="text-lg font-medium">تصفح الفئة</span>
            </div>
          </div>
          
          {/* Category Icon Badge */}
          <div className="category-page-card__icon-badge">
            <Folder size={16} />
          </div>
        </div>
        
        <div className="category-page-card__content">
          <div className="flex items-center justify-between mb-2">
            <h3 className="category-page-card__title">
              {category.name}
            </h3>
            <ChevronRight 
              size={20} 
              className="category-page-card__chevron"
            />
          </div>
          
          {category.description && (
            <p className="category-page-card__description">
              {category.description}
            </p>
          )}
          
          {/* Product count */}
          <div className="category-page-card__product-count">
            <Package size={14} />
            <span>
              {category.product_count !== undefined ? 
                `${category.product_count} منتج` : 
                'منتجات متنوعة'
              }
            </span>
          </div>
        </div>
      </Link>
    </figure>
  )
}

export default CategoryCard
